import { HttpClient } from '@angular/common/http';
import { Injectable, ViewContainerRef } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { ConfigService } from 'src/app/core/services/config.service';
import { SendEmailRequest } from 'src/app/feature-module/documents/models/SendEmailRequest';
import { CustomDialogSettings } from 'src/app/shared/model/CustomDialogSettings';
import { CustomDialogService } from 'src/app/shared/services/custom-dialog.service';
import { ShowDocumentComponent } from '../component/show-document/show-document.component';
import { DocumentInfo } from '../models/DocumentInfo';
import { GenerateImageSetRequest } from '../models/GenerateImageSetRequest';
import { SignPdfDocumentData } from '../models/SignPdfDocumentData';
import { SendSignedDocumentRequest } from '../models/SendSignedDocumentRequest';
import {  GenerateCarRepairInfoCardRequest } from '../models/GenerateCarRepairInfoCardRequest';


@Injectable({
  providedIn: 'root'
})
export class DocumentGenerationService {

  constructor(private http: HttpClient,
    private configService: ConfigService,
    private customDialogService: CustomDialogService,
    private translateService: TranslateService) {
  }

  public generateClaimRegistrationNotificationEmail(sendEmailRequest: SendEmailRequest): Observable<Blob> {
    return this.http.post<Blob>(
      this.configService.PortalWebApiUrl + 'GenerateDocument/email/claimRegistrationNotification', sendEmailRequest, { reportProgress: true, responseType: 'blob' as 'json' });
  }

  public generateInspectionCardPdf(inspectionCardId: number): Observable<Blob> {
    return this.http.post<Blob>(
      this.configService.PortalWebApiUrl + 'GenerateDocument/pdf/inspectionCard', inspectionCardId, { reportProgress: true, responseType: 'blob' as 'json' });
  }

   public generateCalculatorInspectionCardPdf(calculatorInspectionCardId: number): Observable<Blob> {
    return this.http.post<Blob>(
      this.configService.PortalWebApiUrl + 'GenerateDocument/pdf/calculatorInspectionCard', calculatorInspectionCardId, { reportProgress: true, responseType: 'blob' as 'json' });
  }

  public generateCarReceptionDataPdf(carReceptionDataId: number): Observable<Blob> {
    return this.http.post<Blob>(
      this.configService.PortalWebApiUrl + 'GenerateDocument/pdf/carReceptionData', carReceptionDataId, { reportProgress: true, responseType: 'blob' as 'json' });
  }

  public sendSignedDocument(data: SendSignedDocumentRequest): Observable<Blob> {
    return this.http.post<Blob>(
      this.configService.PortalWebApiUrl + 'GenerateDocument/email/sendSignedDocument', data, { reportProgress: true, responseType: 'blob' as 'json' });
  }

  public generateCarRentAgreementPdf(carRentId: number): Observable<Blob> {
    return this.http.post<Blob>(
      this.configService.PortalWebApiUrl + 'GenerateDocument/pdf/carRentAgreement', carRentId, { reportProgress: true, responseType: 'blob' as 'json' });
  }

  public generateCarRentAgreementReturnPdf(carRentId: number): Observable<Blob> {
    return this.http.post<Blob>(
      this.configService.PortalWebApiUrl + 'GenerateDocument/pdf/carRentAgreementReturn', carRentId, { reportProgress: true, responseType: 'blob' as 'json' });
  }

  public generateImageSetPdf(data: GenerateImageSetRequest): Observable<Blob> {
    return this.http.post<Blob>(
      this.configService.PortalWebApiUrl + 'GenerateDocument/pdf/imageSet', data, { reportProgress: true, responseType: 'blob' as 'json' });
  }

  public generateSatisfactionSurvey(sendEmailRequest: SendEmailRequest): Observable<Blob> {
    return this.http.post<Blob>(
      this.configService.PortalWebApiUrl + 'GenerateDocument/email/satisfactionSurvey', sendEmailRequest, { reportProgress: true, responseType: 'blob' as 'json' });
  }

  public signGeneratedDocument(data: SignPdfDocumentData): Observable<string> {
    return this.http.post<string>(
      this.configService.PortalWebApiUrl + 'GenerateDocument/pdf/sign', data);
  }

  public generateCarRepairInfoCard(request: GenerateCarRepairInfoCardRequest): Observable<Blob> {
    return this.http.post<Blob>(
      this.configService.PortalWebApiUrl + 'GenerateDocument/pdf/carRepairInfoCard', request, { reportProgress: true, responseType: 'blob' as 'json' });
  }

    public generateBusinessTripDocumentPdf(businessTripId: number): Observable<Blob> {
    return this.http.post<Blob>(
      this.configService.PortalWebApiUrl + 'GenerateDocument/pdf/businessTripDocument', businessTripId, { reportProgress: true, responseType: 'blob' as 'json' });
  }


  public previewContent(content: Blob, documentName: string, contentType: string, dialogTitle: string, dialogDiv: ViewContainerRef) {

    const documentInfo: DocumentInfo = {
      id: '',
      name: documentName,
      fileIdentifier: '',
      documentTypeId: 0,
      documentKindId: 0,
      otherDocumentKindName: '',
      additionalData: '',
      description: '',
      originalCreationDate: '',
      createdBy: '',
      timestamp: '',
      fileExtension: contentType
    };


    const dialogSettings: CustomDialogSettings = {
      content: ShowDocumentComponent,
      title: `${this.translateService.instant(dialogTitle)}`,
      minHeight: '60vh',
      minWidth: '60vw',
      maxHeight: '90vh',
      maxWidth: '90vw',
      appendTo: dialogDiv,
      dialogInputs: {
        documentInfo: documentInfo,
        documentContent: content,
        fileExtension: documentInfo.fileExtension,
        fileName: documentInfo.name
      }
    };

    this.customDialogService.showDialog(dialogSettings);

  }

}
